import { commonRequest } from '../../../services/ApiCall';
import { Helpers } from '../../../services/Helpers';

export const GeoExpertServices = {
  getActiveExpertsInRadius: async ({ lat, long, radius, type = 'service', filterType, key }) => {
    const queryParams = new URLSearchParams();
    if (lat)        queryParams.append('lat',        lat);
    if (long)       queryParams.append('long',       long);
    if (radius)     queryParams.append('radius',     radius);
    if (type)       queryParams.append('type',       type);
    if (filterType) queryParams.append('filterType', filterType);
    if (key)        queryParams.append('key',        key);

    return await commonRequest(
      'GET',
      `${Helpers.URL()}/api/v2/admin/experts/active-experts-in-radius?${queryParams.toString()}`,
      {},
      Helpers.token()
    );
  },

  getExpertServicesByUserId: async (userId) => {
    return await commonRequest(
      'GET',
      `${Helpers.URL()}/api/v2/admin/experts/expert-services?userId=${userId}`,
      {},
      Helpers.token()
    );
  },

  getExpertServiceDetails: async ({ userId, masterServiceId }) => {
    return await commonRequest(
      'GET',
      `${Helpers.URL()}/api/v2/admin/experts/expert-services?userId=${userId}&masterServiceId=${masterServiceId}`,
      {},
      Helpers.token()
    );
  },
};
